import { render, staticRenderFns } from "./selectedVehicle.vue?vue&type=template&id=4325c9c0&scoped=true"
import script from "./selectedVehicle.vue?vue&type=script&setup=true&lang=js"
export * from "./selectedVehicle.vue?vue&type=script&setup=true&lang=js"
import style0 from "./selectedVehicle.vue?vue&type=style&index=0&id=4325c9c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4325c9c0",
  null
  
)

export default component.exports